const taxonomyTitles = {
  categories: 'Topics',
  'investor-goals': 'Investor Goals',
  plans: 'Plans',
  tags: 'Tags',
}
const getTitle = (key) => taxonomyTitles[key] || ''

function filterTaxonomiesFromKeys(taxonomies, keys) {
  const blogTaxonomies = taxonomies.reduce((accumulator, taxonomy) => {
    const { key, categories = [] } = taxonomy
    const newCategories = categories.filter((category) => {
      return keys.includes(category?.key)
    })
    if (newCategories.length && key == 'categories') {
      accumulator = [
        ...accumulator,
        {
          key,
          categories: newCategories,
        },
      ]
    }
    return accumulator
  }, [])
  return blogTaxonomies
}

export { filterTaxonomiesFromKeys, getTitle }
